<template>
  <div class="home">
    <topbar :imp="navText"></topbar>
    <div id="ban">
      <el-carousel height="614px" trigger="click">
        <el-carousel-item>
          <div><img src="./img/ban01.jpg"></div>
        </el-carousel-item>
        <el-carousel-item>
          <div><img src="./img/ban02.jpg"></div>
        </el-carousel-item>
        <el-carousel-item>
          <div><img src="./img/ban03.jpg"></div>
        </el-carousel-item>
      </el-carousel>
    </div>

    <div class="wrap">
      <div class="conTitle">关于航数</div>
      <div class="conTitle_bor"></div>
      <div class="conText">
        上海航数智能科技有限公司是由国家工信部、中国航发集团、陕西财政厅等下属基金投资上亿元的新一代信息技术企业。核心团队由多位500强前高管、技术专家组成，掌握高端装备亚健康诊断、健康预测、及数字孪生的核心技术，曾参与了多个行业的标准制定，并承接、参与了国家重点研发计划，平均行业经验十年以上。
      </div>
    </div>

    <div class="bgDiv">
      <div class="wrap">
        <div class="conTitle">工业互联网</div>
        <div class="conTitle_bor"></div>
        <div class="conText">
          工业互联网平台是工业系统与人工智能、大数据以及互联网的融合产物。它通过成熟的通讯协议，连接海量设备，在云端对设备上传的工业数据进行深度分析和决策，重构工业运营和维护，激发生产力。它能够实现装备的智能化、管理的智能化、服务的智能化、生产的智能化。
        </div>
      </div>
      <div class="wrap clear">
        <div class="conList">
          <img src="./img/list01.jpg">
          <h6>装备的智能化</h6>
          <p>实现设备的联网和通讯，设备可被远程监测或拥有自我健康状态诊断能力。</p>
        </div>
        <div class="conList">
          <img src="./img/list02.jpg">
          <h6>管理的智能化</h6>
          <p>管理者可通过移动智能终端与员工和设备实时交互，企业管理流程升级再造。</p>
        </div>
        <div class="conList">
          <img src="./img/list03.jpg">
          <h6>服务的智能化</h6>
          <p>线上收集设备的数据，预测潜在故障，线下实施适情维修服务， 防止非计划维修。 </p>
        </div>
        <div class="conList conListR">
          <img src="./img/list04.jpg">
          <h6>生产的智能化</h6>
          <p>基于设备和员工的历史生产数据， 重新规划生产流程、排班，最大 化利用现有资源，提高生产效率。 </p>
        </div>
      </div>
    </div>
   
    <div class="wrap">
      <div class="conTitle">多行业赋能</div>
      <div class="conTitle_bor"></div>
      <div class="conTextCen">携手共赢，助力中国制造2025</div>
      <div class="aboutSwiper">
        <el-carousel height="300" trigger="click" type="card" indicator-position="none">
          <el-carousel-item>
            <!--<div><img src="./img/slider1.jpg" width="600px" height="300px"></div>-->
            <div class="slideBot slider1">航空</div>
          </el-carousel-item>
          <el-carousel-item>
            <!--<div><img src="./img/slider2.jpg"  width="600px" height="300px"></div>-->
            <div class="slideBot slider2">风电</div>
          </el-carousel-item>
          <el-carousel-item>
            <!--<div><img src="./img/slider3.jpg" width="600px" height="300px"></div>-->
            <div class="slideBot slider3">钻机</div>
          </el-carousel-item>
          <el-carousel-item>
            <!--<div><img src="./img/slider4.jpg" width="600px" height="300px"></div>-->
            <div class="slideBot slider4">机床</div>
          </el-carousel-item>
          <el-carousel-item>
            <!--<div><img src="./img/slider5.jpg" width="600px" height="300px"></div>-->
            <div class="slideBot slider5">高铁</div>
          </el-carousel-item>
          <el-carousel-item>
            <!--<div><img src="./img/slider6.jpg" width="600px" height="300px"></div>-->
            <div class="slideBot slider6">油田</div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="hei100"></div>
    </div>
    <div class="bgDiv">
      <div class="wrap">
        <div class="conTitle">产品中心</div>
        <div class="conTitle_bor"></div>
        <div class="conText conTextPro">上海航数智能科技有限公司以“以中国工业数字化为使命”，提供基于工业互联网的健康管理系统一体化解决方案，以及各类相关的数据分析、数据挖掘及大数据平台研发等服务。
        </div>
        <div class="proWrap">
          <img src="./img/pro01.jpg">
          <img src="./img/pro02.jpg">
          <img src="./img/pro03.jpg">
          <img src="./img/pro04.jpg">
        </div>
        <div class="hei100"></div>
      </div>
    </div>
    <div class="wrap">
      <div class="conTitle">解决方案</div>
      <div class="conTitle_bor"></div>
      <div class="conText conTextSolution">
        航数智能研发的系统可应用在多种类型的设备上，包括民用飞机、通航飞机、多功能舰船、民用舰船、风力发电机、各类数控机床、纺织机械、钻矿设备、燃气轮机、石油钻井等，该类技术正促进全球新一轮工业设备智能维修及运营模式的重大变革。
      </div>
      <div class="soluWrap">
        <div class="solu">
          <div>
            <img src="./img/icon01.png">
            <span>民用飞机</span>
          </div>
        </div>
        <div class="solu">
          <div>
            <div class="pl-he">
              <img src="./img/icon02.png" class="plane">
            </div>
            <span>通航飞机</span>
          </div>
        </div>
        <div class="solu">
          <div>
            <img src="./img/icon03.png">
            <span>多功能舰船</span>
          </div>
        </div>
        <div class="solu">
          <div>
            <img src="./img/icon04.png">
            <span>民用舰船</span>
          </div>
        </div>
        <div class="solu">
          <div>
            <img src="./img/icon05.png">
            <span>风力发电机</span>
          </div>
        </div>
      </div>
      <div class="soluWrap">
        <div class="solu">
          <div>
            <img src="./img/icon06.png">
            <span>各类数控机床</span>
          </div>
        </div>
        <div class="solu">
          <div>
            <img src="./img/icon07.png">
            <span>纺织机械</span>
          </div>
        </div>
        <div class="solu">
          <div>
            <img src="./img/icon08.png">
            <span>钻矿设备</span>
          </div>
        </div>
        <div class="solu">
          <div>
            <img src="./img/icon09.png">
            <span>燃气轮机</span>
          </div>
        </div>
        <div class="solu">
          <div>
            <img src="./img/icon10.png">
            <span>石油钻井</span>
          </div>
        </div>
      </div>
      <div class="hei60"></div>
    </div>
    <div class="client">
      <div class="wrap">
        <div class="conTitle colorfff">公司客户</div>
        <div class="conTitle_bor" style="background:#fff;"></div>
        <div class="conText colorfff">
          公司客户包括多个工业巨头及国家级研发单位。</div>
      </div>
    </div>
    <botcon></botcon>
  </div>
</template>

<script>
/* eslint-disable no-undef */
import Topbar from "@/components/base/Topbar/index";
import Botcon from "@/components/base/Botcon/index";
export default {
  name: "Home",
  components: {
    Topbar,
    Botcon
  },
  data() {
    return {
      navText: {
        text: "首页"
      }
    };
  },
  created() {
    this.$nextTick(() => {
      setTimeout(() => {
        let r = window.innerWidth - document.body.clientWidth;
        this.$store.commit("setScroll", r);
      }, 20);
    });
  },
  methods: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#ban {
  width: 100%;
  height: auto;
}

#ban img {
  display: block;
  width: 100%;
  height: auto;
}

.conTitle {
  height: 180px;
  text-align: center;
  font-size: 50px;
  line-height: 52px;
  padding-top: 89px;
  color: #3e3e3e;
}

.conTitle_bor {
  width: 90px;
  height: 1px;
  margin: 0 auto;
  background: #ccc;
}

.conText {
  padding: 20px 130px 78px;
  color: #5e5e5e;
  font-size: 22px;
  line-height: 40px;
  font-weight: lighter;
  text-align: center;
}

.conTextCen {
  height: 77px;
  text-align: center;
  padding-top: 18px;
  color: #3e3e3e;
  font-size: 22px;
  line-height: 25px;
  font-weight: lighter;
}

.conTextPro {
  padding: 20px 130px 20px !important;
}

.conTextSolution {
  padding: 20px 130px 0 !important;
}

.conList {
  width: 279px;
  height: 453px;
  margin-right: 28px;
  float: left;
}

.conList:last-child {
  margin-right: 0 !important;
}

.conList img {
  display: block;
  width: 279px;
  height: 237px;
}

.conList h6 {
  font-size: 26px;
  color: #3e3e3e;
  padding: 17px 0 18px;
}

.conList p {
  font-size: 18px;
  color: #3e3e3e;
  line-height: 26px;
}

.aboutSwiper {
  width: 1200px;
  height: 300px;
}

.swiperBot .swiper-wrapper img {
  display: block;
  width: 1200px;
  height: 400px;
}

.hei100 {
  width: 100%;
  height: 100px;
}

.hei60 {
  width: 100%;
  height: 60px;
}

.bgDiv {
  width: 100%;
  height: auto;
  background: #eef0f5;
}

.proWrap {
  height: 259px;
  display: flex;
  justify-content: space-between;
}

.proWrap img {
  display: block;
  width: 290px;
  height: 259px;
}

.soluWrap {
  height: 240px;
  padding-top: 28px;
  display: flex;
  justify-content: space-between;
}

.solu {
  width: 230px;
  height: 230px;
  padding-bottom: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #e5e5e5;
  border: #e5e4e5 solid 1px;
}

.pl-he {
  width: 140px;
  height: 120px;
  display: flex;
  align-items: flex-end;
}

.plane {
  display: block;
  width: 140px;
  height: 80px !important;
  margin-block-end: 14px;
}

.solu img {
  display: block;
  width: 140px;
  height: 120px;
}

.solu span {
  display: block;
  font-size: 24px;
  line-height: 28px;
  padding-top: 10px;
  color: #3e3e3e;
  text-align: center;
}

.client {
  width: 100%;
  height: 427px;
  background: url("./img/botBg.jpg") no-repeat center top;
}

.colorfff {
  color: #fff !important;
}

.slideBot {
  width: 600px;
  height: 400px;
  font-size: 36px;
  color: #fff;
  line-height: 40px;
  display: flex;
  margin: 0;
  align-items: center;
  justify-content: center;
}

.slider1 {
  background: url("./img/slider1.jpg");
  width: 600px;
  height: 300px;
}

.slider2 {
  background: url("./img/slider2.jpg");
  width: 600px;
  height: 300px;
}

.slider3 {
  background: url("./img/slider3.jpg");
  width: 600px;
  height: 300px;
}

.slider4 {
  background: url("./img/slider4.jpg");
  width: 600px;
  height: 300px;
}

.slider5 {
  background: url("./img/slider5.jpg");
  width: 600px;
  height: 300px;
}

.slider6 {
  background: url("./img/slider6.jpg");
  width: 600px;
  height: 300px;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/index.vue